import { gql } from "apollo-boost";

export const GET_CATEGORYS = gql`
query Data($where: CategoryWhereInput) {
    categories(where: $where) {
      data {
        id
        name
        image
        coverImages
        detail
        level
        status
        isDeleted
        createdAt
        updatedAt
        note
        shop {
          id 
        } 
      }
      total
    }
  }
`;
 